// @flow

import { type Theme } from './types';
import defaultTheme from './default-theme';

const theme: Theme = {
  ...defaultTheme,
  button: {
    ...defaultTheme.button,
    fontFamily: 'sansSerif',
    fontWeight: '600',
    rounded: false,
    textTransform: 'uppercase',
  },
  colors: {
    ...defaultTheme.colors,
    black: 'hsl(0, 0%, 20%)',
  },
};

export default theme;
